export default "__VITE_ASSET__66890917__"